import { API_START, API_END } from "../actions/types";

const initialState = {
  isPending: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case API_START:
      return {
        ...state,
        isPending: true
      };

    case API_END:
      return {
        ...state,
        isPending: false
      };

    default:
      return state;
  }
}
